import React, { useState, useEffect } from 'react';
import helper from 'components/utils/helper';
import { Container, Form, Text, Button } from './CookieBar.style';

const CookieBar = ({cms, loggedIn}) => {
    const [isActive, setIsActive] = useState(false);
    const [bannerContent, setBannerContent] = useState();
    const [buttonText, setButtonText] = useState();
    const CookieName = 'cookies_notified'

    useEffect(() => {
        let cookiesNotified = helper.getCookie(CookieName);
        if (cookiesNotified !== CookieName && (cms && cms.siteSettings && cms.siteSettings.cookieBanner)){
            let {cookieBannerBlock, cta } = cms.siteSettings.cookieBanner;
            setBannerContent(cookieBannerBlock);
            setButtonText(cta);
            setIsActive(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function onAcceptCookie(){
        helper.setCookie(CookieName, CookieName, 365);
        setIsActive(false);
    }

    return (
      <Container isVisible={isActive} loggedIn={loggedIn}>
          <Form>
              { bannerContent && <Text>{helper.renderParagraph(bannerContent)}</Text>}
              <Button onClick={() => onAcceptCookie()}>
                  {buttonText}
              </Button>
          </Form>
      </Container>
    );
}
 
export default CookieBar;